import React, { Component } from 'react';
import axios from 'axios';
import UserVideos from './UserVideos';
import SearchPreferences from './SearchPreferences';
import { toast } from 'react-toastify';
import { getLoginApiBase, getSocketApiBase } from '../utils/apiBase';

class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userVideos: [],
            loadingVideos: true,
            searchPreferences: {
                categories: [],
                duration: 'all',
                quality: 'all',
                sort: 'recent'
            }
        };
    }

    componentDidMount() {
        if (this.props.loggedIn && this.props.userEmail) {
            this.fetchUserVideos();
            this.loadSearchPreferences();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.loggedIn && this.props.loggedIn) {
            this.fetchUserVideos();
            this.loadSearchPreferences();
        }
    }

    fetchUserVideos = async () => {
        const userId = sessionStorage.getItem('user_id');
        if (!userId) {
            this.setState({ userVideos: [], loadingVideos: false });
            return;
        }

        try {
            const response = await axios.get(`${getLoginApiBase()}/user/${userId}/videos`);
            this.setState({
                userVideos: response.data?.data?.videos || [],
                loadingVideos: false
            });
        } catch (error) {
            console.error('Error fetching user videos:', error);
            this.setState({ loadingVideos: false });
        }
    };

    loadSearchPreferences = () => {
        // Load from localStorage or API
        const savedPreferences = localStorage.getItem('searchPreferences');
        if (savedPreferences) {
            this.setState({
                searchPreferences: JSON.parse(savedPreferences)
            });
        }
    };

    handlePreferencesUpdate = (newPreferences) => {
        this.setState({ searchPreferences: newPreferences });
        localStorage.setItem('searchPreferences', JSON.stringify(newPreferences));
        // TODO: Save to backend API
    };

    handleVideoDelete = async (video) => {
        const userId = sessionStorage.getItem('user_id');
        if (!userId || !video?.id) {
            toast.error('Sign in again to delete videos');
            return;
        }

        try {
            if (video.minioPath) {
                await axios.delete(`${getSocketApiBase()}/user-upload/${userId}`, {
                    params: { path: video.minioPath }
                });
            }
            await axios.delete(`${getLoginApiBase()}/user/${userId}/videos/${video.id}`);
            this.setState({
                userVideos: this.state.userVideos.filter((v) => v.id !== video.id)
            });
            toast.success('Video deleted');
        } catch (error) {
            console.error('Delete video failed:', error);
            toast.error('Could not delete video');
        }
    };

    render() {
        const { loggedIn, userEmail } = this.props;
        const { userVideos, loadingVideos, searchPreferences } = this.state;

        if (!loggedIn) {
            return (
                <div className="home-page">
                    <div className="login-prompt">
                        <div className="prompt-icon">🏠</div>
                        <h2>Welcome to Lick Before You Stick</h2>
                        <p>Please login to access your personal homepage</p>
                        <button 
                            className="header-btn primary"
                            onClick={this.props.handleLoginShow}
                        >
                            Login
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className="home-page">
                <div className="home-header">
                    <h1>Welcome back, {userEmail?.split('@')[0]}!</h1>
                    <p className="home-subtitle">Manage your videos and search preferences</p>
                </div>

                <div className="home-content">
                    <div className="home-section">
                        <h2 className="section-title">
                            <span className="section-icon">📹</span>
                            Your Uploaded Videos
                        </h2>
                        <UserVideos 
                            videos={userVideos}
                            loading={loadingVideos}
                            onVideoSelect={this.props.onVideoSelect}
                            onVideoDelete={this.handleVideoDelete}
                        />
                    </div>

                    <div className="home-section">
                        <h2 className="section-title">
                            <span className="section-icon">⚙️</span>
                            Search Preferences
                        </h2>
                        <SearchPreferences
                            preferences={searchPreferences}
                            onUpdate={this.handlePreferencesUpdate}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default HomePage;